import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import SizesMap, { defaultSize, sizes } from './Input.number.sizes'
import { colors } from '../../../constants'

const Input = styled.input`
    background: ${colors.greylightest};
    ${({ borderColor }) => (borderColor ? `border: 1px solid ${borderColor};` : `border: 1px solid ${colors.greylight};`)}
    border-radius: 3px;
    outline: none;
    padding: 5px;

    &:active,
    &:focus,
    &:hover {
        border: 1px solid ${colors.grey};
    }

    ${({ error }) =>
        error &&
        `
    border: 1px solid ${colors.red};
  `}

    ${({ size }) => {
        switch (size) {
            case SizesMap.xs:
                return 'width: 50px;'
            case SizesMap.sm:
                return 'width: 115px;'
            case SizesMap.md:
                return 'width: 250px;'
            case SizesMap.lg:
                return 'width: 400px;'
            case SizesMap.none:
            default:
                return ''
        }
    }}
`

const defaultValue = 0

const InputNumber = React.forwardRef(({ onChange, size, value, borderColor, ...props }, ref) => (
    <Input type="number" onChange={onChange} ref={ref} size={size} value={value || defaultValue} borderColor={borderColor} {...props} />
))

InputNumber.propTypes = {
    onChange: PropTypes.func,
    size: PropTypes.oneOf(sizes),
    value: PropTypes.number,
    borderColor: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

InputNumber.defaultProps = {
    onChange: () => null,
    size: defaultSize,
    value: defaultValue,
    borderColor: null,
}

export default InputNumber
